import React from 'react';
import '../assets/scss/orderPackages.scss';

const OrderPackages = ({
	name,
	register,
	setValue,
	formData,
	options,
	setSelectedServices,
}) => {
	const selectedOption = formData?.[name];

	const handleLabelClick = (optionValue) => {
		const newValue = optionValue === selectedOption ? null : optionValue;
		setValue('additionalServices', {});
		if (typeof setSelectedServices === 'function') {
			setSelectedServices({});
		}
		setValue(name, newValue);
	};

	return (
		<div className='order-packages'>
			<h2 className='sectionTitle'>Bestillingspakker</h2>
			<div className='titleDesc'>
				<p>Velg pakken som passer deg best</p>
			</div>
			<div className='order-packages__container'>
				{options.map((option, index) => {
					const isSelected = selectedOption === option.value;
					return (
						<div key={index} className='radio-box'>
							<input
								type='radio'
								name={name}
								id={`${name}-${index}`}
								value={option.value}
								className='hidden-radio'
								{...register(name, {
									required: 'Velg en bestillingspakke',
								})}
								onClick={() => handleLabelClick(option.value)}
							/>
							<label
								htmlFor={`${name}-${index}`}
								className={`custom-radio ${isSelected ? 'selected' : ''}`}
							>
								<div className='content-box'>
									<div className='title'>{option.title}</div>
									<div className='border'></div>
									<ul className='description'>
										{option.service}
									</ul>
								</div>
								<div
									className={`order-status ${isSelected ? 'chosen' : 'order'}`}
								>
									{isSelected ? 'Pakke valgt' : 'Bestill pakke'}
								</div>
							</label>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default OrderPackages;
